import api from "@/vue-dlb/utils/backend-api";
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";
import appUtil from '@/vue-dlb/utils/app-util';
import idb from '@/vue-dlb/utils/idb';

import {  
  commitRetDataSets
} from "@/vue-dlb/utils/sys-util.js";

import {
  selectDataSetByDataSet,
  callByDataSet,
} from "@/vue-dlb/utils/backend-util.js";

const state = {
  masterItems: [],
  dataItems: [],
  editext: "",
  biztext: "",
  dataSet01Source: [],
  filter: {},
  fileViewWindowParam: {}
};

const getters = {
};

const actions = {
  getSummaryList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("masterItems");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getSummaryList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_ANALYSIS_LIST_PRCS_MST_SRM_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);    
    await api.putData("UserDispatcherServlet", reqdata).then(res => {      
      commitRetDataSets(commit, res.data);
    });
  },
  getSummaryDataList: async ({ commit }, searchItems) => {        
    const retSet = new ObjDataSet("dataItems");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getSummaryDataList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_ANALYSIS_LIST_PRCS_MST_SUB_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {      
      commitRetDataSets(commit, res.data);
    });
  },
  getSummaryDataListIndexDb: async ({ commit }, searchItems) => {        
    const retSet = new ObjDataSet("dataItems");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getSummaryDataList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_ANALYSIS_LIST_PRCS_MST_SUB_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {    
      idb.saveData(res.data);  
    });
  },
  queryGrepDataList: async ({ commit }, searchItems) => {        
    const retSet = new ObjDataSet("dataItems");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryGrepDataList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_ANALYSIS_LIST_PRCS_DATA_GREP_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {      
      commitRetDataSets(commit, res.data);
    });
  },    
  deleteProcessData: async ({ commit }, paramItems) => {    
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("deleteProcessData");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "DataAnalysisManager";
    trSet.tranMethod = "deleteDataAnalysisProcData";
    const reqdata = callByDataSet(trSet);    
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  readEDIFile: async ({ commit }, edipath) => {
    console.log('edipath:' + edipath);
    let reqdata =  {FILE_ID: edipath};
    api.readFile("EDIFileView", reqdata).then(res => {      
      commit('setEDIText', res.data);
    });
  },
  readBizFile: async ({ commit }, bizpath) => {    
    console.log('bizpath:' + bizpath);
    let reqdata =  {FILE_ID: bizpath};
    api.readFile("FileView", reqdata).then(res => {      
      commit('setBizText', res.data);
    });
  },
};

const mutations = {
  masterItems (state, datarows) {
    state.masterItems = datarows;
    state.dataSet01Source = datarows;
  },
  dataItems (state, datarows) {
    state.dataItems = datarows;
  },
  setEDIText (state, data) {    
    state.editext = data;
  },
  setBizText (state, data) {    
    state.biztext = data;
  },
  'SET_STORE_ANALYSIS_FILTER' (state, filter) {
    let datarows = state.dataSet01Source;
    state.filter = filter;
    let filterBy = state.filter;
    let listResult = [];
    if (filterBy != null) {
      let filter = filterBy.filter;
      let str = filterBy.str;
      if (str.trim() == '') {
        listResult = datarows;
      }
      listResult = datarows.filter(item =>  {
        if(filter == 'all') {
          for (const prop in item) {
            if (typeof item[prop] == 'string') {
              let propValue = item[prop].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[prop] == 'number') {
              let propValue = item[prop].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
        } else {
          if (typeof item[filter] == 'string') {
            let propValue = item[filter].toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          } else if (typeof item[filter] == 'number') {
            let propValue = item[filter].toString().toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          }
        }

        return false;
      });
    }
    state.masterItems = listResult;
  },
  'SET_FILEVIEW_WINDOW_PARAM' (state, fileView) {
    let fileViewWindowParam = state.fileViewWindowParam;
    fileViewWindowParam[fileView['ROWID']] = fileView;
    state.fileViewWindowParam = fileViewWindowParam;
  },
  'DELETE_FILEVIEW_WINDOW_PARAM' (state, fileView) {
    let fileViewWindowParam = state.fileViewWindowParam;
    delete fileViewWindowParam[fileView['ROWID']];
    state.fileViewWindowParam = fileViewWindowParam;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
